import { render } from "./OnItsWayToPharmacy.vue?vue&type=template&id=1636e5a4"
import script from "./OnItsWayToPharmacy.vue?vue&type=script&lang=js"
export * from "./OnItsWayToPharmacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__